import React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExecutiveClientPraise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [googleReviews, setGoogleReviews] = React.useState<Array<{
    author_name: string;
    text: string;
    rating: number;
  }>>([]);
  React.useEffect(() => {
    const fetchGoogleReviews = async () => {
      const mockReviews = [{
        author_name: "Marcus V.",
        text: "Elyon Maintenance transformed our commercial complex. Their attention to detail in landscaping and janitorial services is unmatched in the industry.",
        rating: 5
      }, {
        author_name: "Sarah L.",
        text: "The one-stop-shop model is a lifesaver. From power washing to interior painting, they handle everything with absolute professionalism and care.",
        rating: 5
      }, {
        author_name: "David K.",
        text: "Reliable, consistent, and high-quality. Our facility has never looked better since we switched to Elyon for our monthly maintenance needs.",
        rating: 5
      }];
      setGoogleReviews(mockReviews);
    };
    fetchGoogleReviews();
  }, []);
  return;
}